import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(picture: string, id_object: string) {
    const requestBody = {
      id_object,
      picture,
    }
    const response = await api.fetch(`/api/v2/pictures/delete`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return await handleResponse(response)
  }
}
